import React from 'react';
import { SingleCalendarProps } from '../interfaces';
import { Days, Months, Years } from '../components';
import { SingleCalendarHeader } from './components';
import { useSingeCalendar } from './useSingeCalendar';
import classNames from 'classnames';
import './SingleCalendar.scss';

export const SingleCalendar: React.FC<SingleCalendarProps> = (props) => {
    const {
        onDateSelect,
        currentValue,
        hideMonth,
        hideYear,
        initialMount,
        initialYear,
        enabledDates,
        initialMode,
        onCustomYearSelect,
        onCustomMonthSelect,
    } = props;

    const {
        viewMonth,
        viewYear,
        viewDates,
        yearMode,
        monthMode,
        dayMode,
        selectedDate,
        onMonthClick,
        onYearClick,
        dateSelect,
        onMonthSelect,
        onYearSelect,
        prevMonthClick,
        nextMonthClick,
        prevYearClick,
        nextYearClick,
    } = useSingeCalendar({
        onDateSelect,
        currentValue,
        initialMount,
        initialYear,
        initialMode,
    });

    return (
        <div className='ui-single-calendar'>
            <SingleCalendarHeader
                viewMonth={viewMonth}
                viewYear={viewYear}
                onMonthClick={!hideMonth ? onMonthClick : undefined}
                onYearClick={!hideYear ? onYearClick : undefined}
                prevMonthClick={!hideMonth ? prevMonthClick : undefined}
                nextMonthClick={!hideMonth ? nextMonthClick : undefined}
                prevYearClick={prevYearClick}
                nextYearClick={nextYearClick}
            />
            <div className='ui-single-calendar__select-area-wrapper'>
                <Days
                    className={classNames('ui-single-calendar__select-area', {
                        none: !dayMode,
                    })}
                    selectedDate={selectedDate}
                    onDateSelect={dateSelect}
                    dates={viewDates}
                    viewMonth={viewMonth}
                    enabledDates={enabledDates}
                    prevMonthHandler={prevMonthClick}
                    nextMonthHandler={nextMonthClick}
                />
                <Months
                    className={classNames('ui-single-calendar__select-area', {
                        none: !monthMode,
                    })}
                    selectedMonth={selectedDate?.month() || null}
                    onMonthSelect={onCustomMonthSelect || onMonthSelect}
                    viewYear={viewYear}
                />
                <Years
                    className={classNames('ui-single-calendar__select-area', {
                        none: !yearMode,
                    })}
                    viewYear={viewYear}
                    selectedYear={selectedDate?.year() || null}
                    onYearSelect={onCustomYearSelect || onYearSelect}
                />
            </div>
        </div>
    );
};
